// 알림 개수 저장
import { defineStore } from "pinia";
import * as cmUtil from "@/utils/cmUtil";

export const useAlimCountStore = defineStore({
  id: "alimCount",
  state: () => ({
    alimCount: 0,
  }),
  actions: {
    setAlimCount(count) {
      this.alimCount = count;
      cmUtil.setLocalStorage("gv.alimCount", count);
    },
  },
});
